import styled from "styled-components";
import Button, {
  buttonThemes
} from "@streeteasy/design-system/deprecated/actions/button";
import { iconSizes } from "@streeteasy/design-system/icon";
import CalendarIcon from "@streeteasy/design-system/icon/brand/CalendarIcon";
import Dismissable from "@streeteasy/design-system/legacy/Dismissable";
import { PrimarySmall } from "@streeteasy/design-system/typography";

export const ModalWrapper = styled(Dismissable)`
  padding: 24px;
  width: 400px;
`;

export const ModalIcon = styled(CalendarIcon).attrs({ size: iconSizes.SM })``;

export const ModalText = styled(PrimarySmall)`
  margin: 24px 0;
`;

export const ModalButton = styled(Button).attrs({
  theme: buttonThemes.SECONDARY
})`
  width: 100%;
`;
